import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { TOKEN_STORE } from './token-store';

/**
 * Attaches the bearer token to outgoing requests and clears it on a 401 (so the
 * route guards send the user back to login). Register via
 * `provideHttpClient(withInterceptors([authInterceptor]))`.
 */
export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const store = inject(TOKEN_STORE);
  const token = store.get();
  const authed = token
    ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : request;

  return next(authed).pipe(
    catchError((error: unknown) => {
      if (typeof error === 'object' && error !== null && 'status' in error && (error as { status: number }).status === 401) {
        store.clear();
      }
      return throwError(() => error);
    }),
  );
};
